/** page size for mail query  */
export const MAIL_QUERY_PAGE_SIZE = 25;

/** page size for people query */
export const PEOPLE_QUERY_PAGE_SIZE = 25;

/** Timezone */
export const UTC_TIMEZONE = 'UTC';

/** Header constants */
export const CLIENT_SESSION_ID = 'client-session-id';

export const CLIENT_SESSION_LOCAL_TIME = 'x-client-localtime';

export const GRIFFIN_VERSION = 'X-Search-Griffin-Version';

export const ACCEPT_LANGUAGE = 'Accept-Language';
